import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ReportService from '../../../services/reports';
import { normalizeReportParams } from '../../../helpers/reportQuery';
import { normalizeReportsOverviewPayload } from '../../../helpers/normalizeReportsAdminResponse';

const emptyOverview = normalizeReportsOverviewPayload({});

const initialState = {
  loading: false,
  ordersSummary: emptyOverview.ordersSummary,
  ordersSeries: [],
  topLines: [],
  categoryBreakdown: [],
  snapshotNote: '',
  carts: undefined,
  error: '',
};

export const fetchReportsOverview = createAsyncThunk(
  'report/fetchReportsOverview',
  (params = {}) =>
    ReportService.getReportsOverview(
      normalizeReportParams({ ...params, format: 'json' })
    ).then((res) => res)
);

const overviewSlice = createSlice({
  name: 'overviewReport',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchReportsOverview.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchReportsOverview.fulfilled, (state, action) => {
      state.loading = false;
      const n = normalizeReportsOverviewPayload(action.payload);
      state.ordersSummary = n.ordersSummary;
      state.ordersSeries = n.ordersSeries;
      state.topLines = n.topLines;
      state.categoryBreakdown = n.categoryBreakdown;
      state.snapshotNote = n.snapshotNote;
      state.carts = n.carts;
      state.error = '';
    });
    builder.addCase(fetchReportsOverview.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default overviewSlice.reducer;
